import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MainContainer from '../../../components/MainContainer';
import { headerData } from '../../../data/modules/dashboard-header';
import Grid from '@material-ui/core/Grid';
import Spacer from "../../../components/Spacer";
import SuivirapportmissionTable from './SuivirapportmissionTable';


const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    elevation: 0
  },
  paperLeaveInDay:{    
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    elevation: 0
  },
  tab1:{
    width: "40%"
  }
}));

export default function Suivirapportmission() {

  const classes = useStyles()
  const [value, setValue] = React.useState(0);

  return (
    <MainContainer {...headerData}>
      <Grid container xs={12}>
            <SuivirapportmissionTable/>
      </Grid>
      <Spacer y={2} />
    </MainContainer>
  );
}
